import {  institutionConstants, nameSpace } from "../constants/institution.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const viewInstitution = (state = initialState, action) => {
  switch (action.type) {
    case institutionConstants[`VIEW_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case institutionConstants[`VIEW_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case institutionConstants[`VIEW_${nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        response: null,
        error: action.error
      };
    case institutionConstants[`VIEW_${nameSpace}_RESET`]:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
